module.exports = __webpack_public_path__ + "static/media/chevron-white.2dc2f7ab.svg";